var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7246 9.13735L9.76544 14.0965C8.81242 15.0495 7.19144 14.9723 6.14312 13.924C5.09481 12.8757 5.01762 11.2547 5.97063 10.3017L11.361 4.91131C11.9561 4.31622 12.9703 4.36452 13.6249 5.01912C14.2795 5.67373 14.3278 6.68797 13.7327 7.28307L9.20484 11.811C8.96767 12.0481 8.56016 12.0287 8.29926 11.7678C8.03837 11.5069 8.01896 11.0994 8.25614 10.8623L12.3528 6.7656L11.6413 6.05407L7.54461 10.1507C6.94952 10.7458 6.99782 11.7601 7.65242 12.4147C8.30703 13.0693 9.32127 13.1176 9.91637 12.5225L14.4443 7.99459C15.3973 7.04158 15.3201 5.4206 14.2718 4.37228C13.2235 3.32396 11.6025 3.24677 10.6495 4.19979L5.25911 9.59014C3.94817 10.9011 4.05425 13.1288 5.49628 14.5708C6.93831 16.0128 9.16603 16.1189 10.477 14.808L15.4361 9.84888L14.7246 9.13735Z",
    fill: "#005FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.e34553a4.svg";
export { ForwardRef as ReactComponent };